// //mobile  单位转换 px 转 rem
// setFontSize();
// function setFontSize(){
//     var _self = this;
//     _self.width = 750; //设置默认最大宽度
//     _self.fontSize = 100; //默认字体大小
//     _self.widthProportion = function(){
//       var p = (document.body && document.getElementsByTagName("html")[0].offsetWidth || document.getElementsByTagName("html" )[0].offsetWidth)/_self.width;
//      return p>1?1:p<0.426?0.426:p;
//     };
//     _self.changePage = function(){
//         document.getElementsByTagName("html" )[0].setAttribute("style", "font-size:"+_self.widthProportion()*_self.fontSize+"px !important");
//         //  alert(_self.widthProportion());
//     };
//     //窗口大小改变
//     _self.changePage();
//     window.addEventListener('orientationchange' ,function(){_self.changePage();}, false);
// }

(function (doc, win) { 
  var sUserAgent = navigator.userAgent.toLowerCase();
  var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
  var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
  var bIsMidp = sUserAgent.match(/midp/i) == "midp";
  var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
  var bIsAndroid = sUserAgent.match(/android/i) == "android";
  var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
  var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
  var isPc = false;
  if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
  }else{
    isPc = true;
  }

  var docEl = doc.documentElement;
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  var recalc = function () {
    var clientWidth = docEl.clientWidth;
    if (!clientWidth) return;
    var ua = navigator.userAgent.toLowerCase();
    if(/ipad/i.test(ua)){
      clientWidth = clientWidth * 0.75;
    }
    if(!isPc){
      return docEl.style.fontSize = parseInt(100 * (clientWidth / 320) * 320 / 750,10) + 'px';
    }
    var height = document.body.clientHeight;
    var width = document.body.clientWidth;
    $('body').addClass('pc');
    $('html').css('font-size', '50px').css('height', '100vh').css('overflow', 'auto');
    $('body').css('background-color', '#fff').css('height', '100%').css('width', '414px').css('margin', 'auto').css('height', '736px');  
  };
  if (!doc.addEventListener) return; 
  doc.addEventListener(resizeEvt, recalc, false);
  $(document).ready(recalc);
  
})(document, window);


//////////////////
// WEBPACK FOOTER
// ./static/js/rem-px.js
// module id = yCGO
// module chunks = 82